export { register, themes, CustomLayout, TYPES, TABLE_EVENT_TYPE } from '@visactor/vtable';
